export default "__VITE_ASSET__DNv8Bqlz__"